import React from 'react';
import * as S from './styled';
export const Badge = ({ emoji, text, borderColor, backgroundColor, textColor }) => {
    const getEmoji = () => {
        if (emoji.startsWith('http')) {
            return React.createElement(S.Image, { src: emoji, alt: "emoji" });
        }
        return React.createElement(S.Emoji, null, emoji);
    };
    return (React.createElement(S.Badge, { style: { borderColor, backgroundColor, color: textColor } },
        getEmoji(),
        " ",
        React.createElement(S.Text, null, text)));
};
